module.exports = __webpack_public_path__ + "img/gc_country_flag_pe.74bdf16f.svg";